import { useCallback, useEffect, useRef, useState } from "react";
import { useDispatch } from "react-redux";
import { axiosInstance } from "../config";
import { getNotification } from "../reduxToolkit/features/adminPanel/notification";
import { invalidateAdminMedicineCatalogue, invalidateStorefrontMedicines } from "../reduxToolkit/features/adminPanel/medicine";
export default function useTranslationStatus() {
  const [data, setData] = useState(null), [error, setError] = useState("");
  const previous = useRef({});
  const dispatch = useDispatch();
  const refresh = useCallback(async () => {
    const { data: next } = await axiosInstance.get("/api/translations/status");
    const activities = [...next.runs, ...(next.batches || [])];
    if (activities.some(run => previous.current[run.id] && previous.current[run.id] !== run.status && run.progress === 100)) {
      dispatch(getNotification());
      if(activities.some(run=>run.scope!=="research"&&["completed","completed_with_errors"].includes(run.status)&&previous.current[run.id]&&previous.current[run.id]!==run.status)){
        dispatch(invalidateAdminMedicineCatalogue());dispatch(invalidateStorefrontMedicines());
      }
    }
    previous.current = Object.fromEntries(activities.map(run => [run.id, run.status]));
    return next;
  }, [dispatch]);
  useEffect(() => {
    let live = true, busy = false;
    async function load() {
      if (busy) return;
      busy = true;
      try { const next = await refresh(); if (live) { setData(next); setError(""); } }
      catch (e) { if (live) setError(e.response?.data?.message || "Translation activity could not be refreshed. Accepted jobs remain saved on the server."); }
      finally { busy = false; }
    }
    load(); const timer = setInterval(load, 5000);
    return () => { live = false; clearInterval(timer); };
  }, [refresh]);
  return { data, setData, error, refresh };
}
